import { useSearchBox } from "react-instantsearch-hooks-web"
import cx from "classnames"
import SearchIcon from "../../icons/SearchIcon"
import SvgIcon from "../../shared/components/SvgIcon"
import { useWorkbenchStore } from "../../store/store"
import { resultsFilters } from "./FilterTransforms"
import { useEffect, useState } from "react"

const WorkbenchSearchFilterListItem = ({ item }) => {
  const setSelectedResultsFilter = useWorkbenchStore((state) => state.setSelectedResultsFilter)
  const selectedResultsFilter = useWorkbenchStore((state) => state.selectedResultsFilter)

  const handleSearchFilterClick = (e) => {
    setSelectedResultsFilter(e.currentTarget.dataset.value)
  }

  return (
    <div 
      className={cx("item", selectedResultsFilter === item.name ? "selected" : "")} 
      data-value={item.name} 
      data-cy={item.name} 
      onClick={handleSearchFilterClick}
    >
      {selectedResultsFilter === item.name && 
        <SvgIcon svgClass="CheckIcon" fillRule="evenodd">
          <polygon
            className="icon-border"
            points="11.941,28.877 0,16.935 5.695,11.24 11.941,17.486 26.305,3.123 32,8.818"
          />
        </SvgIcon>
      }
      <span>
        {item.name}
      </span>
    </div>
  )
}

const WorkbenchSearch = () => {
  const { refine, query } = useSearchBox()
  const searchQuery = useWorkbenchStore((state) => state.searchQuery)
  const setSearchQuery = useWorkbenchStore((state) => state.setSearchQuery)
  const selectedResultsFilter = useWorkbenchStore((state) => state.selectedResultsFilter)
  const [searchQueryForm, setSearchQueryForm] = useState(searchQuery)
  const [isMenuVisible, setIsMenuVisible] = useState(false)

  const handleSearchChange = (e) => {
    setSearchQueryForm(e.target.value)
  }

  const handleSearchSubmit = (e) => {
    e.preventDefault()
    setSearchQuery(searchQueryForm)
  }

  const handleMenuToggle = () => {
    setIsMenuVisible(!isMenuVisible)
  }

  useEffect(() => {
    if (searchQuery !== query) {
      refine(searchQuery)
    }
    setSearchQueryForm(searchQuery) // Resyncs form state in case of back navigation
  }, [searchQuery, query, refine])

  return (
    <form id="search" className="search mm-filter" onSubmit={handleSearchSubmit}>
      <div id="mm-search-input">
        <div className="search-input-group">
          <div className="icon">
            <SearchIcon />
          </div>
          <label>Search</label>
          <input
            autoFocus
            type="text"
            value={searchQueryForm}
            onChange={handleSearchChange}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="none"
            spellCheck="false"
            placeholder="Search by song, artist or lyrics"
            aria-label="Enter search text"
          />
        </div>
        <div className="search-filter" onClick={handleMenuToggle}>
          <span className="expand icon"></span>
          <div className="target">
            {selectedResultsFilter} <span></span>
          </div>
          <div className={cx("menu", isMenuVisible ? "visible" : "")}>
            {resultsFilters.map((item, index) => (
              <WorkbenchSearchFilterListItem key={index} item={item} />
            ))}
          </div>
        </div>
      </div>
    </form>
  )
}

export default WorkbenchSearch
